<style scoped>
@media (max-width: 350px) {
    button {
        @apply text-sm mx-1;
    }
}
</style>

<template>
    <div>
        <div
            v-if="showRouterLinks"
            class="text-base sm:text-lg text-secondary my-4 flex"
        >
            <router-link
                tag="button"
                to="/account/accountInfo"
                class="inline-block border-b-2 border-transparent mr-2 sm:mr-4 focus:outline-none"
                activeClass="text-darkGrayishBlue border-darkGrayishBlue font-black"
            >
                {{ $t('account.info') }}
            </router-link>
            <!-- <div class=" border&#45;l border&#45;gray&#45;500"></div> -->
            <router-link
                tag="button"
                to="/account/orderHistory"
                class="inline-block border-b-2 border-transparent mx-2 sm:mx-4 focus:outline-none"
                activeClass="text-darkGrayishBlue border-darkGrayishBlue font-black"
            >
                {{ $t('order.history') }}
            </router-link>
            <router-link
                v-if="$config.displayCreditPointLayout()"
                :disabled="!$config.enableCreditPoint()"
                tag="button"
                to="/account/creditPointHistory"
                class="inline-block border-b-2 border-transparent mx-2 sm:mx-4 focus:outline-none"
                activeClass="text-darkGrayishBlue border-darkGrayishBlue font-black"
            >
                {{ $t('credit.point.history') }}
            </router-link>
            <router-link
                tag="button"
                to="/account/purchasedProduct"
                class="inline-block border-b-2 border-transparent mx-2 sm:mx-4 focus:outline-none"
                activeClass="text-darkGrayishBlue border-darkGrayishBlue font-black"
            >
                {{ $t('purchased.order.history') }}
            </router-link>
            <router-link
                tag="button"
                to="/account/feedback"
                class="inline-block border-b-2 border-transparent mx-2 sm:mx-4 focus:outline-none"
                activeClass="text-darkGrayishBlue border-darkGrayishBlue font-black"
            >
                {{ $t('product.feedback') }}
            </router-link>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showRouterLinks: false
        };
    }
};
</script>
